<template>
  <div class='flex space-x-2 justify-center items-center'>
    <span class='sr-only'>Loading</span>
    <div class='h-4 w-4 bg-white rounded-full animate-bounce [animation-delay:-0.3s]'/>
    <div class='h-4 w-4 bg-white rounded-full animate-bounce [animation-delay:-0.15s]'/>
    <div class='h-4 w-4 bg-white rounded-full animate-bounce'/>
  </div>
</template>